import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const DocumentEditorStore = lazy(() =>
  import('src/pages/document/document-editor').then((module) => ({ default: module.DocumentEditorStore }))
);

const DocumentFilloutStore = lazy(() =>
  import('src/pages/document/documentFillout').then((module) => ({
    default: module.DocumentFilloutStore,
  }))
);
const DocumentViewStore = lazy(() =>
  import('src/pages/document/documentView').then((module) => ({
    default: module.DocumentViewStore,
  }))
);
const ParticipantByDocumentStore = lazy(() =>
import('src/pages/document/ParticipantByDocument').then((module) => ({
  default: module.ParticipantByDocumentStore,
}))
);
const DocumentList = lazy(() => import('src/pages/document/document-list'));


const FormByParticipantStore = lazy(() =>
  import('src/pages/form/FormByParticipant').then((module) => ({
    default: module.FormByParticipantStore,
  }))
);

const DocumentByParticipant = lazy(() => import('src/pages/document/documentByParticipant'));

// ----------------------------------------------------------------------

export const DocumentOrganizationRoutes = [
  {
    path: 'documents',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <DocumentList />, index: true },
      // { path: 'edition', element: <DocumentEditorStore /> },
      { path: 'edition', element: <DocumentEditorStore /> },
      { path: 'participant', element: <DocumentByParticipant /> },
      { path: ':id/users/:userid/results', element: <DocumentFilloutStore /> },
      { path: ':id/:participant', element: <ParticipantByDocumentStore /> },
      { path: ':id/users/:userID/view', element: <DocumentViewStore /> },
      { path: 'peview', element: <DocumentViewStore /> },
    ],
  },
];

export const DocumentParticipantRoutes = [
  {
    path: '/trainees/documents',
    element: (
      <AuthGuard allowedRoles={['trainee']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <DocumentByParticipant />, index: true },
      { path: ':id/users/:traineeID/:participant', element: <DocumentFilloutStore /> },
      { path: ':id/view', element: <DocumentViewStore /> },
    ],
  },
  /* {
    path: 'forms/:id/filled/:participant',
    element: (
      <FormLayout>
        <Suspense fallback={<LoadingScreen />}>
          <FormFillingOutStore />
        </Suspense>
      </FormLayout>
    ),
  }, */
]; 
